import React from 'react';
import { PlansFeatureMeta, ProfessionalFeatureMeta } from './feature-meta';
import {
  Feature,
  FeaturesList,
} from '../../../../../../../../../shared/design-system/components/molecules/all-features-list-modal/types';
import { OverlayTooltip } from '../../../../../../../../../shared/design-system/components/overlay/tooltip/overlay-tooltip';
import { Placement } from '../../../../../../../../../shared/design-system/components/overlay';

const FeaturesSection: React.FC<FeaturesList> = ({ id, features }) => (
  <div key={id} className="features-section">
    {features.map((feature: Feature, index: number) => (
      <div
        className="feature d-flex"
        key={feature.featureId}
        style={{ backgroundColor: index % 2 === 0 ? '#f9fafb' : '#fff' }}
      >
        <div className="font-14 blue-txt-15 d-flex align-items-center feature-name">
          {feature?.tooltipText ? (
            <div className="feature-tooltip pointer feature-name-container">
              <OverlayTooltip
                text={feature?.tooltipText}
                placement={feature?.tooltipPlacement ?? Placement.BottomStart}
              >
                <span>{feature?.featureName || ''}</span>
              </OverlayTooltip>
            </div>
          ) : (
            feature.featureName
          )}
        </div>
        <PlansFeatureMeta
          isAvailable={feature.starterFeatureMeta?.isAvailable}
          isLimited={feature.starterFeatureMeta?.isLimited}
          text={feature.starterFeatureMeta?.text}
          tooltipText={feature.starterFeatureMeta?.tooltipText}
          isComingSoon={feature.starterFeatureMeta?.isComingSoon}
          limitedAccessTooltipText={
            feature.starterFeatureMeta?.limitedAccessTooltipText
          }
          className="starter-plan-meta"
        />
        <ProfessionalFeatureMeta
          isAvailable={feature.professionalFeatureMeta?.isAvailable}
          isLimited={feature.professionalFeatureMeta?.isLimited}
          text={feature.professionalFeatureMeta?.text}
          tooltipText={feature.professionalFeatureMeta?.tooltipText}
          isComingSoon={feature.professionalFeatureMeta?.isComingSoon}
          limitedAccessTooltipText={
            feature.professionalFeatureMeta?.limitedAccessTooltipText
          }
          className={`cst-meta ${index % 2 === 0 ? 'even' : 'odd'}`}
        />
        <PlansFeatureMeta
          isAvailable={feature.businessFeatureMeta?.isAvailable}
          isLimited={feature.businessFeatureMeta?.isLimited}
          text={feature.businessFeatureMeta?.text}
          tooltipText={feature.businessFeatureMeta?.tooltipText}
          isComingSoon={feature.businessFeatureMeta?.isComingSoon}
          limitedAccessTooltipText={
            feature.businessFeatureMeta?.limitedAccessTooltipText
          }
          className="cst-meta"
        />
        <PlansFeatureMeta
          isAvailable={feature.scalePlusFeatureMeta?.isAvailable}
          isLimited={feature.scalePlusFeatureMeta?.isLimited}
          text={feature.scalePlusFeatureMeta?.text}
          tooltipText={feature.scalePlusFeatureMeta?.tooltipText}
          isComingSoon={feature.scalePlusFeatureMeta?.isComingSoon}
          limitedAccessTooltipText={
            feature.scalePlusFeatureMeta?.limitedAccessTooltipText
          }
        />
        <PlansFeatureMeta
          isAvailable={feature.customFeatureMeta?.isAvailable}
          isLimited={feature.customFeatureMeta?.isLimited}
          text={feature.customFeatureMeta?.text}
          isComingSoon={feature.customFeatureMeta?.isComingSoon}
          limitedAccessTooltipText={
            feature.customFeatureMeta?.limitedAccessTooltipText
          }
          className="cst-meta"
        />
      </div>
    ))}
  </div>
);

export default FeaturesSection;
